:host {
  /* height will be set to match the survey content height */
  --content-height: 100%;

  /* hide modal until it is hydrated to prevent FOUC */
  hp6-modal:not(.hydrated),
  hp6-floating-action-button:not(.hydrated) {
    display: none;
  }

  hp6-modal {
    background-color: var(--color-background-base);
    border: 1px var(--color-neutral-light);

    hp6-overlay {
      z-index: 11; // to cover site-navigation (z-index: 10)
    }

    .feedback-modal-content {
      display: flex;
      flex-direction: column;
      max-height: 90vh;
      height: -webkit-fill-available;

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        word-break: break-word;
        padding: var(--spacing-sm);
        padding-left: var(--spacing-md);

        hp6-icon-button {
          height: auto;
        }
      }

      .modal-body {
        overflow-y: auto;
        padding: var(--spacing-xs) var(--spacing-md);

        .survey-form {
          width: 100%;
          overflow: auto;
          height: var(--content-height);
          border: none;
        }
      }
    }
  }

  hp6-floating-action-button button {
    /* FAB just behind the overlay */
    z-index: 10;
  }
}
